import type { ReactNode } from 'react';
import type { ClientPackProblem, ClientPackVerification } from '@mcpanel/core';
import { ClientPackLogs } from './ClientPackLogs';

export function ClientPackProblems({
  check,
  actions,
  modpackProjects = [],
}: {
  check: ClientPackVerification;
  actions?: (problem: ClientPackProblem) => ReactNode;
  modpackProjects?: string[];
}) {
  const unknown =
    check.state === 'failed' && !check.problems?.some((problem) => problem.projectId && problem.kind !== 'unavailable');
  return (
    <div className="stack client-pack-problems">
      {check.reason && <p className="alert warn">{check.reason}</p>}
      {check.problems?.map((problem, index) => (
        <div className="card card-body stack" key={index}>
          <strong>{problem.title ?? problem.modId ?? '構成の問題'}</strong>
          {problem.projectId && modpackProjects.includes(problem.projectId) && (
            <span className="tag">Modpack から導入</span>
          )}
          <p>{problem.message}</p>
          {problem.modId && <span className="small muted">Mod ID: {problem.modId}</span>}
          {actions?.(problem)}
        </div>
      ))}
      {unknown && <p>原因の Mod を特定できませんでした</p>}
      <details open={unknown || (!check.problems && check.state === 'failed')}>
        <summary>ログとクラッシュレポート</summary>
        <ClientPackLogs check={check} />
      </details>
    </div>
  );
}
